import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Modal from "react-bootstrap/Modal";
import { ITermsOfServiceModalProps } from "./TermsOfServiceModalProps";
import { StyledDialog } from "./TermsOfServiceModalHelpers";
import { useTermsOfServiceModalSliceContext } from "../../../context/SliceContexts/TermsOfServiceModalContext";

const TermsOfServiceModal: React.FC<ITermsOfServiceModalProps> = () => {
  const { show, onHide } = useTermsOfServiceModalSliceContext();
  const data = useStaticQuery(graphql`
    {
      allNodeGenericPage(
        filter: { path: { alias: { eq: "/travel-pass/terms-conditions" } } }
      ) {
        edges {
          node {
            title
            path {
              alias
            }
            body {
              processed
              value
            }
          }
        }
      }
    }
  `);

  let terms = null;
  if (data.allNodeGenericPage.edges.length) {
    terms = data.allNodeGenericPage.edges[0].node;
  }
  return (
    <StyledDialog show={show} onHide={onHide} aria-label="Terms of Service">
      <Modal.Header closeButton>
        <Modal.Title id="termsofservice-modal">
          {" "}
          Travel Pass terms and conditions{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {terms && (
          <div dangerouslySetInnerHTML={{ __html: terms.body?.processed }} />
        )}
      </Modal.Body>
    </StyledDialog>
  );
};

export default TermsOfServiceModal;
